import React from "react";
import { enqueueSnackbar } from "notistack";
import { isApp } from "../../../../hooks/useNativeApp";
import {
  ButtonWrapper,
  ContentWrapper,
  DialogWrapper,
  FormContainer,
} from "../style/PopupStyles";
import { useRecoilState, useSetRecoilState } from "recoil";
import { userState } from "../../../../recoil/auth";
import {
  registerCompanyReservation,
  CompanyReservationParams,
  cancelCompanyReservation,
} from "../../../../api/company-reservation";
import { loadingState } from "../../../../recoil/app";

interface ReservationPopupProps {
  onClose: () => void;
  getData?: () => void;
  reservationId: number;
  setIsFinalReservation?: (value: boolean) => void;
  keepSeed: number;
  type: string;
  tournamentName: string;
  id?: number;
}

const CompanyReservationPopup: React.FC<ReservationPopupProps> = ({
  onClose,
  getData,
  reservationId,
  setIsFinalReservation,
  keepSeed,
  type,
  tournamentName,
  id,
}) => {
  const [user] = useRecoilState(userState);
  const setIsLoading = useSetRecoilState(loadingState);
  const createReservation = async () => {
    if (!user || !reservationId) return;
    const body: CompanyReservationParams = {
      reservationId: +reservationId,
      userId: user.id,
      route: isApp ? "APP" : "WEB",
    };
    if (user.seed) {
      if (keepSeed > user.seed) {
        enqueueSnackbar("보유 래빗이 부족합니다. ");
        return;
      }
    } else {
      enqueueSnackbar("보유 래빗이 부족합니다. ");
      return;
    }
    try {
      setIsLoading(true);
      await registerCompanyReservation(body);
      if (getData) {
        getData();
        enqueueSnackbar("예약되었습니다.", { variant: "success" });
      }
      setIsFinalReservation && setIsFinalReservation(true);
      onClose();
    } catch (error: any) {
      onClose();
      enqueueSnackbar(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelReservation = async () => {
    if (!user || !id) return;

    try {
      setIsLoading(true);
      await cancelCompanyReservation(id);
      setIsFinalReservation && setIsFinalReservation(true);
      onClose();
    } catch (error: any) {
      onClose();
      enqueueSnackbar(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogWrapper>
      <FormContainer>
        <ContentWrapper>
          {type === "reservation" ? (
            <>
              <div className="seed-wrapper">
                <div className="title">보유 통합 크레딧</div>
                <div className="seed">
                  {user?.seed ? user?.seed.toLocaleString() : 0} RABBIT
                </div>
              </div>
              <div className="content">토너먼트를 예약 하시겠습니까?</div>
              <div className="waring">
                *통합 크레딧 {keepSeed}RABBIT 만큼 차감됩니다.
                <br />
                "*00시 기준 대회 시작 3일 전에는 예약 취소가 불가능합니다."
              </div>
            </>
          ) : (
            <>
              <div className="content-cancel">
                {tournamentName}
                <br />
                예약을 취소하시겠습니까?
              </div>
            </>
          )}
        </ContentWrapper>
        <ButtonWrapper>
          <div className="button" onClick={() => onClose()}>
            아니오
          </div>
          <div
            className="button purple"
            onClick={() => {
              if (type === "reservation") {
                createReservation();
              } else {
                cancelReservation();
              }
            }}
          >
            예
          </div>
        </ButtonWrapper>
      </FormContainer>
    </DialogWrapper>
  );
};

export default CompanyReservationPopup;
